import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";

import { ReactComponent as CancelIcon } from "../static/icons/cancel.svg";

const AppModal = ({ title, open, onClose, children }) => {
  return (
    <Modal
      show={open}
      onHide={onClose}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          <Container>
            <Row>
              <Col xs={10} sm={8} md={11} xl={11}>
                {title}
              </Col>
              <Col xs={2} sm={3} md={1} xl={1}>
                {onClose && <CancelIcon onClick={onClose} />}
              </Col>
            </Row>
          </Container>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default AppModal;
